<template style="background-color:white">
  <section class="init_box" style="background-color: white">
    <el-row type="flex" justify="end" style="flex-wrap: wrap; flex-direction: row">
      <el-col :span="24" style="margin-top: 15px; padding-left: 10px">
        <el-button class="btn" size="small" type="primary" @click="toDeviceinAdd">添加</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('131') != -1"
          @click="clickUpdateBtn">编辑</el-button>
        <el-button class="btn" size="small" type="primary" @click="applyBorrowing"
          v-if="btnRole.indexOf('209') != -1">借用申请</el-button>
        <el-button class="btn" size="small" type="primary" @click="outMarket"
          v-if="btnRole.indexOf('217') != -1">划出设备超市</el-button>
        <el-button class="btn" size="small" type="primary" @click="export2Excel"
          v-if="btnRole.indexOf('211') != -1">导出台账</el-button>
        <el-button class="btn" size="small" type="primary" @click="deviceCardsClick">设备卡片</el-button>
        <el-button class="btn" size="small" type="primary" @click="assetCardClick">资产卡片</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('13') != -1"
          @click="clickWeiBao">申请维保</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('19') != -1"
          @click="clickBaoFei">申请报废</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('11') != -1"
          @click="clickCheck">检定录入</el-button>
        <el-button class="btn" size="small" type="primary" @click="exportAssetCardClick">导出资产卡片</el-button>
        <el-button class="btn" size="small" type="primary" v-if="btnRole.indexOf('132') != -1"
          @click="importExcelDialog = true">Excel导入</el-button>
        <el-button class="btn" size="small" type="primary" @click="changeShelvesHandle"
          v-if="btnRole.indexOf('210') != -1">变更货架</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 15px; flex-wrap: wrap; flex-direction: row" type="flex" justify="end">
      <el-col :span="5" style="float: left; margin-top: 10px">
        <el-button type="primary" class="statueBtn" style="background-color: rgb(64, 149, 229)"></el-button><span
          class="statueSpan" style="">可借</span>
        <el-button type="primary" class="statueBtn" style="background-color: red"></el-button><span class="statueSpan"
          style="">不可借</span>
      </el-col>
      <!-- 搜索框 -->
      <el-col :span="19">
        <el-form :model="searchModel" :inline="true" style="float: right">
          <el-form-item label="资产名称">
            <el-input placeholder="请输入资产名称" v-model="searchModel.zcmc" clearable style="width: 160px"></el-input>
          </el-form-item>
          <el-form-item label="管理编号">
            <el-input placeholder="请输入管理编号" v-model="searchModel.glbh" clearable style="width: 160px"></el-input>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input placeholder="请输入查询厂家、编号、类型、名称" auto-complete="off" prefix-icon="el-icon-search"
              v-model="searchModel.search" style="width: 100%; margin-right: 55px" clearable>
            </el-input>
          </el-form-item>
          <el-form-item label="是否可借">
            <el-select placeholder="请选择" v-model="searchModel.borrowStatus" clearable style="width: 120px">
              <el-option label="可借" :value="0"></el-option>
              <el-option label="不可借" :value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="" size="small" @click="searchDeviceinfo">搜索</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!-- 筛选框按钮，可筛选显示的列 -->
      <el-col :span="24" style="float: left">
        <!-- <el-button style="float: right;margin-right: 15px;" icon="iconfont icon-liebiao"></el-button> -->
        <el-dropdown :hide-on-click="false" style="float: right; margin-right: 15px">
          <i class="iconfont icon-liebiao"></i>
          <el-dropdown-menu slot="dropdown">
            <el-scrollbar style="height: 60vh"><!--作用是数据过多把表单数据的整体高度固定、多出的区域可以下拉展示-->
              <el-checkbox-group v-model="check">
                <el-dropdown-item v-for="(item, index) in checkList" :key="index">
                  <el-checkbox :label="item" :key="item"> </el-checkbox>
                </el-dropdown-item>
              </el-checkbox-group>
            </el-scrollbar>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
      <!-- 数据展示表格 -->
      <el-col :span="24" style="margin-top: 5px">
        <el-table :data="deviceData" ref="deviceTable" id="deviceTable" @selection-change="changeCheckBoxValue"
          :header-cell-style="{ background: '#eff3f6' }" stripe :row-key="getRowKeys" style="
            width: 99%;
            margin: 0px auto;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          " height="600">
          <el-table-column type="selection" width="55" :reserve-selection="true" style="border-color: black">
          </el-table-column>
          <el-table-column type="index" label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.$index + (pageIndex - 1) * pagesize + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column v-if="item.prop == 'zcmc' && item.ispass" v-for="(item, index2) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index2" :label="item.label" :fixed="false"
            show-overflow-tooltip>
            <template slot-scope="scope" v-if="item.label == '资产名称'">
              <el-link :underline="false" style="color: rgb(64, 149, 229); text-decoration: none"
                @click="toDetail(scope.row)">
                {{ scope.row.zcmc }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column v-for="(item, index1) in deviceTable" v-if="item.prop == 'glbh' && item.ispass"
            :width="item.width" :prop="item.prop" :key="index1" :label="item.label" :fixed="false" show-overflow-tooltip
            :row-key="(row) => {
              return row.classId;
            }
              ">
            <template slot-scope="scope" v-if="item.prop == 'glbh'">
              <el-link :underline="false" v-if="scope.row.sbzt == '42'" style="color: red; text-decoration: none"
                @click="toDetail(scope.row)">
                {{ scope.row.glbh }}
              </el-link>
              <el-link :underline="false" v-if="scope.row.sbzt == '4'" style="color: #580fda; text-decoration: none"
                @click="toDetail(scope.row)">
                {{ scope.row.glbh }}
              </el-link>
              <el-link :underline="false" v-if="
                scope.row.sbzt == '41' ||
                scope.row.sbzt == '43' ||
                scope.row.sbzt == '44'
              " style="color: #d2b309; text-decoration: none" @click="toDetail(scope.row)">
                {{ scope.row.glbh }}
              </el-link>
              <el-link :underline="false" v-if="
                scope.row.sbzt != '42' &&
                scope.row.sbzt != '4' &&
                scope.row.sbzt != '41' &&
                scope.row.sbzt != '43' &&
                scope.row.sbzt != '44'
              " style="color: #4095e5; text-decoration: none" @click="toDetail(scope.row)">
                {{ scope.row.glbh }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column align="center" v-if="item.prop == 'sbzt' && item.ispass"
            v-for="(item, index8) in deviceTable" :width="item.width" :prop="item.prop" :key="index8"
            :label="item.label" :fixed="item.fixed" show-overflow-tooltip>
            <template slot-scope="scope" v-if="item.prop == 'sbzt'">
              {{ scope.row.statusName }}
            </template>
          </el-table-column>
          <el-table-column :width="100" label="借用状态" show-overflow-tooltip align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.borrowStatus == '0'" style="color: rgb(64, 149, 229)">可借</span>
              <span v-else style="color: red">不可借</span>
            </template>
          </el-table-column>
          <el-table-column label="货架号" prop="shelvesText" show-overflow-tooltip width="120">
          </el-table-column>
          <el-table-column align="center" width="130" label="使用年限/年" :formatter="formateUseTime">
          </el-table-column>
          <el-table-column v-if="item.prop == 'yjfl' && item.ispass" v-for="(item, index4) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index4" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateYjfl">
          </el-table-column>
          <el-table-column v-if="item.prop == 'ejfl' && item.ispass" v-for="(item, index5) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index5" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateEjfl">
          </el-table-column>
          <el-table-column v-if="item.prop == 'zyfl' && item.ispass" v-for="(item, index6) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index6" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateZyfl">
          </el-table-column>
          <el-table-column v-if="item.prop == 'xmfl' && item.ispass" v-for="(item, index7) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index7" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip :formatter="formateXmfl">
          </el-table-column>
          <el-table-column v-else-if="
            item.prop != 'glbh' &&
            item.prop != 'dbzt' &&
            item.prop != 'zcmc' &&
            item.prop != 'id' &&
            item.prop != 'sydw' &&
            item.prop != 'bz' &&
            item.prop != 'yjfl' &&
            item.prop != 'ejfl' &&
            item.prop != 'zyfl' &&
            item.prop != 'xmfl' &&
            item.prop != 'sbzt' &&
            item.prop != 'syr' &&
            item.ispass
          " :width="item.width" :prop="item.prop" :key="item.prop" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
          </el-table-column>

          <el-table-column v-if="item.prop == 'bz' && item.ispass" v-for="(item, index10) in deviceTable"
            :width="item.width" :prop="item.prop" :key="index10" :label="item.label" :fixed="item.fixed"
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="操作" width="230" fixed="right" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="viewBorrowDetail(scope.row)">借用记录</el-button>
              <el-button type="text" size="small" @click="viewDeviceUsageRecord(scope.row)">使用记录</el-button>
              <el-button type="text" size="small" @click="viewDeviceMaintenanceRecord(scope.row)">维护记录</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination v-if="total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]" :page-size="pagesize" :current-page="pageIndex"
          layout="total, sizes, prev, pager, next, jumper" :total="total" style="float: right">
        </el-pagination>
      </el-col>
    </el-row>
    <!-- 添加显示购物车按钮，如果复选框有选中让显示，否则不显示 -->
    <div style="
        position: fixed;
        top: 175px;
        left: 500px;
        height: 50px;
        width: 50px;
        font-size: 20px;
      " @click="checkBoxdialog = true" v-if="checkBoxData.length > 0">
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <!-- <span class="iconfont icon--task- " style="width:100%;height:100%;font-size: 40px"></span> -->
        <img src="../../../static/img/selects.png" style="width: 70%; height: 70%; font-size: 40px" />
      </el-badge>
    </div>
    <!-- 显示购物车列表 -->
    <el-dialog title="已选择设备" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="checkBoxdialog">
      <el-button type="primary" size="mini" @click="removeAllCheckbox"
        style="margin-top: -30px; float: left">清空内容</el-button>
      <el-table :data="checkBoxData" v-if="checkBoxNumber > 0" :header-cell-style="{ background: '#eff3f6' }"
        style="padding-top: 5px">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column property="zcmc" label="资产名称"></el-table-column>
        <el-table-column property="zcbh" label="资产编号"></el-table-column>
        <el-table-column property="glbh" label="管理编号"></el-table-column>
        <el-table-column property="sbxh" label="设备型号"></el-table-column>
        <el-table-column label="操作" style="text-decoration: none">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="removeThisData(scope.row)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <!-- 办公设备卡片 -->
    <el-dialog title="办公设备卡片" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="deviceCarddialogbg" width="450px" @close="closeDialog">
      <!-- <deviceCardbg v-if="showType.indexOf('办公设备') != -1" ref="banGongCard" :deviceinfo="deviceDataDetail"
                style="margin-top:-30px;"></deviceCardbg> -->
      <device-cardbg v-if="showType.indexOf('办公设备') != -1" ref="banGongCard" :deviceinfo="deviceDataDetail"
        style="margin-top: -30px"></device-cardbg>
    </el-dialog>
    <!-- 检测设备卡片 -->
    <el-dialog title="检测设备卡片" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="deviceCarddialog" width="370px" @close="closeDialog">
      <DeviceinfoCard v-if="showType.indexOf('检测设备') != -1" ref="jianceCard" :deviceinfo="deviceDataDetail"
        style="margin-top:-30px;padding-left:50px'"></DeviceinfoCard>
    </el-dialog>
    <!------biu-->
    <!-- 批量办公设备卡片 -->
    <el-dialog title="办公设备卡片" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="deviceCarddialogbgPL" width="450px" @close="closeDialog">
      <deviceCardjcPL v-if="showType.indexOf('办公设备') != -1" ref="selectBanGongCard" :deviceinfo="deviceDataDetail"
        style="margin-top: -30px"></deviceCardjcPL>
    </el-dialog>
    <!-- 批量检测设备卡片 -->
    <el-dialog title="检测设备卡片" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="deviceCarddialogPL" width="370px" @close="closeDialog">
      <deviceinfoCardPL v-if="showType.indexOf('检测设备') != -1" ref="selectJianceCard" :deviceinfo="deviceDataDetail"
        style="margin-top:-30px;padding-left:50px'"></deviceinfoCardPL>
    </el-dialog>
    <!-- 资产卡片 -->
    <el-dialog title="资产卡片" :close-on-click-modal="false" style="margin-top: -130px" :close-on-press-escape="false"
      :visible.sync="assetCardDialog" width="70%">
      <div height="“60px">
        <el-button type="primary" v-print="printAccet" style="float: left">打印</el-button>
        <el-button type="primary" @click="downloadAssetCard" style="float: left; margin-right: 10px">下载</el-button>
      </div>
      <div id="printAsset" ref="printContent">
        <div ref="docxView" id="assetDiv"></div>
      </div>
    </el-dialog>
    <!-- 申请维保、申请报废、检定录入、资产调拨、调入确认 -->
    <el-dialog :title="dialogTitle" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="dialogShow" width="35%" @close="closeDialog">
      <!-- 点击维保申请按钮显示 -->
      <WeibaoApplyVue v-if="showType.indexOf('维保') != -1" ref="weibaoApply" :deviceinfo="checkBoxData" @func="isShow"
        @select="getDeviceinfo"></WeibaoApplyVue>
      <!-- 点击申请报废按钮显示 -->
      <baoFeiApplyVue v-if="showType.indexOf('报废') != -1" ref="baoFeiApply" :deviceinfo="checkBoxData" @func="isShow"
        @select="getDeviceinfo"></baoFeiApplyVue>
      <!-- 点击检定录入按钮显示 -->
    </el-dialog>

    <!-- 导出设备卡片预览 -->
    <el-dialog :visible.sync="showCards" title="导出设备卡片" :close-on-click-modal="false" :close-on-press-escape="false"
      width="600px">
      <div>
        <iframe :src="'/sysbgl/pdfjs/web/viewer.html?file=' +
          encodeURIComponent(
            '/sbgl_api/deviceinfo/cards.pdf?ids=' + exportIds
          )
          " width="560" height="500">
        </iframe>
      </div>
    </el-dialog>

    <!-- Excel导入 -->
    <el-dialog title="excel导入" :close-on-click-modal="false" :close-on-press-escape="false"
      :visible.sync="importExcelDialog" width="350px" @close="closeExcelDialog">
      <el-form ref="excelForm" :model="excelForm" label-width="80px">
        <el-form-item label="导入设备" prop="deviceExcel" :rules="{ required: true }">
          <el-upload class="upload-demo" action="string" style="align: left" :on-preview="handlePreview"
            :on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed"
            :file-list="fileList" :auto-upload="false" :http-request="uploadFile" :on-change="handleChange"
            :before-upload="beforeUpload" accept=".xlsx">
            <el-button size="mini" type="info" plain :loading="uploadBool">
              {{ uploadBool ? "文件上传中..." : "导入设备" }}
            </el-button>
          </el-upload>
          <div class="upload__tips">仅支持上传.xlsx文件</div>
          <el-button type="text" @click="download">下载设备导入模板</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickUpload" v-if="excelLoading == false">上传文件</el-button>
          <el-button type="primary" v-if="excelLoading == true">上传中……</el-button>
          <el-button @click="importExcelDialog = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!----------借用申请/编辑草稿----------->
    <el-dialog :visible.sync="borrowVisible" :title="editingBorrowId ? '编辑草稿' : '借用申请'"
      :close-on-click-modal="false" :close-on-press-escape="false" width="1100px">
      <el-form :model="borrowForm" ref="borrowForm" :rules="borrowRules" label-position="left" label-width="100px">
        <el-row>
          <el-col :span="12" align="left">
            <el-form-item label="项目名称" prop="projectName" v-if="otherChecked">
              <el-input v-model="borrowForm.projectName" placeholder="请输入项目名称" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item label="项目名称" prop="projectName" v-if="!otherChecked">
              <el-select v-model="borrowForm.projectName" ref="projectNameSelect" @change="selectProject" filterable
                placeholder="请选择项目名称" style="width: 100%">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12" align="left">
            <el-checkbox v-model="otherChecked" @change="otherChange" size="medium"
              style="margin-top: 10px; margin-left: 20px">其他项目</el-checkbox>
            <span style="margin-left: 20px"> * 勾选后请输入项目名称</span>
          </el-col> -->
        </el-row>
        <el-row>
          <el-col :span="16" align="left">
            <el-form-item label="所属区域" prop="addressIds">
              <el-cascader style="width: 100%" ref="cascader" class="cascader" v-if="borrowForm.addressName"
                v-model="borrowForm.addressIds" :props="propsAddress" @change="handleCascaderChange"
                :placeholder="borrowForm.addressName" />
              <el-cascader style="width: 100%" v-else v-model="borrowForm.addressIds" :props="propsAddress"
                @change="handleCascaderChange" placeholder="选择所属地域" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16" align="left">
            <el-form-item label="详细地址" prop="addressDetail">
              <el-input placeholder="请输入详细地址" v-model.trim="borrowForm.addressDetail" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="借用日期" prop="borrowDate">
              <el-date-picker v-model.trim="borrowForm.borrowDate" type="daterange" value-format="yyyy-MM-dd"
                align="right" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                :picker-options="datePickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="领用方式" prop="getType">
              <el-radio v-model="borrowForm.getType" label="1">自取</el-radio>
              <el-radio v-model="borrowForm.getType" label="2">邮寄</el-radio>
              <el-radio v-model="borrowForm.getType" label="3">委托他人</el-radio>
              <div style="margin-top: 10px">
                <div v-if="borrowForm.getType == 2">
                  <el-input style="display: inline-block; width: 120px" placeholder="收件人姓名"
                    v-model.trim="borrowForm.name" />
                  <el-input style="display: inline-block; width: 160px" placeholder="收件人电话"
                    v-model.trim="borrowForm.phone" />
                  <el-input style="display: inline-block; width: 400px" placeholder="收件人地址"
                    v-model.trim="borrowForm.address" />
                </div>
                <div v-if="borrowForm.getType == 3">
                  <el-input placeholder="委托人姓名" v-model.trim="borrowForm.persion" style="width: 150px" />
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="资产列表" prop="sccj" class="required">
              <el-table :header-cell-style="{
                textAlign: 'center',
                background: '#eff3f6',
              }" :cell-style="{ textAlign: 'center' }" ref="multipleTable" max-height="300"
                :data="borrowForm.deviceList" tooltip-effect="dark" style="width: 100%; text-align: center" stripe>
                <el-table-column :label="lable.index" type="index" show-overflow-tooltip>
                </el-table-column>
                <el-table-column sortable prop="glbh" label="管理编号" show-overflow-tooltip width="120">
                </el-table-column>
                <el-table-column prop="zcmc" label="设备名称" show-overflow-tooltip align="left">
                </el-table-column>
                <el-table-column prop=" zcbh" :label="lable.zcbh" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="syr" :label="lable.originalName" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="sccj" label="生产厂家" show-overflow-tooltip>
                </el-table-column>
                <el-table-column label="操作" show-overflow-tooltip>
                  <template slot="header" slot-scope="scope">
                    <DC :transferValue="transferValue" :parameter="{ isMarket: '1' }" :isMarket="true"
                      :initialSelected="editingBorrowId ? borrowForm.deviceList : []"></DC>
                  </template>
                  <template slot-scope="scope">
                    <el-button type="text" @click="deleteClick(scope.row)" size="small">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="borrowCancel">取 消</el-button>
        <el-button @click="saveDraft">保存草稿</el-button>
        <el-button type="primary" @click="submitAudit">提交审核</el-button>
      </span>
    </el-dialog>

    <!----------变更货架----------->
    <el-dialog :visible.sync="changeShelvesVisible" title="变更货架" :close-on-click-modal="false"
      :close-on-press-escape="false" width="480px">
      <el-form :model="changeShelvesForm" ref="changeShelvesForm" :rules="changeShelvesRules" label-position="left"
        label-width="100px">
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="原货架" prop="oldIdText">
              <el-input v-model.trim="changeShelvesForm.row.shelvesText" readonly />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="新货架" prop="newIds">
              <el-cascader style="width: 100%" ref="cascader2" v-model="changeShelvesForm.newIds" :props="shelvesProps"
                @change="handleCascader2Change" placeholder="选择新货架" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeShelvesVisible = false">取 消</el-button>
        <el-button type="primary" @click="changeShelvesOk">确 定</el-button>
      </span>
    </el-dialog>
    <!----------划出设备超市----------->
    <el-dialog :visible.sync="toMarketShow" title="划出设备超市" :close-on-click-modal="false" :close-on-press-escape="false"
      width="700px">
      <el-form :model="toMarketForm" ref="toMarketForm" :rules="toMarketRules" label-position="left"
        label-width="100px">
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="保管人" prop="bgr">
              <el-input placeholder="请输入保管人" v-model.trim="toMarketForm.bgr" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" align="left">
            <el-form-item label="使用部门" prop="sydw">
              <el-cascader v-model="toMarketForm.sydw" style="width: 100%" :options="companySelect"
                :props="companyProps" clearable :show-all-levels="false" filterable placeholder="请选择单位"></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24" align="left" style="padding-bottom: 10px">
            划出设备清单：
          </el-col>
          <el-col :span="24" align="left">
            <el-table :data="checkBoxData" size="small" style="width: 100%">
              <el-table-column prop="zcmc" label="资产名称" align="left">
              </el-table-column>
              <el-table-column prop="glbh" label="管理编号"> </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="toMarketShow = false">取 消</el-button>
        <el-button type="primary" @click="outMarketOk" v-preventReClick>确 定</el-button>
      </span>
    </el-dialog>

    <!-- 借用详情弹窗 -->
    <el-dialog :visible.sync="borrowDetailShow" title="借用记录" width="80%" :close-on-click-modal="false">
      <el-table :data="borrowDetailList" style="width: 100%"
        :header-cell-style="{ background: '#eff3f6', textAlign: 'center' }">
        <el-table-column prop="mktBorrowRecord.projectName" label="项目名称" show-overflow-tooltip align="left">
          <template slot-scope="scope">
            {{ scope.row.mktBorrowRecord ? scope.row.mktBorrowRecord.projectName : '' }}
          </template>
        </el-table-column>
        <el-table-column label="借用人" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.mktBorrowRecord ? scope.row.mktBorrowRecord.userName : '' }}
          </template>
        </el-table-column>
        <el-table-column label="借用日期" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.mktBorrowRecord && scope.row.mktBorrowRecord.createTime ?
              scope.row.mktBorrowRecord.createTime.substring(0, 10) : '' }}
          </template>
        </el-table-column>
        <el-table-column label="出库时间" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.outTime ? scope.row.outTime.substring(0, 10) : '--' }}
          </template>
        </el-table-column>
        <el-table-column label="入库时间" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.inTime ? scope.row.inTime.substring(0, 10) : '--' }}
          </template>
        </el-table-column>
        <el-table-column label="出库是否完好" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.outTime">--</span>
            <span v-else-if="scope.row.devicestatusOut == '1'" style="color: red">否</span>
            <span v-else style="color: green">是</span>
          </template>
        </el-table-column>
        <el-table-column label="入库是否完好" width="120" align="center">
          <template slot-scope="scope">
            <span v-if="!scope.row.inTime">--</span>
            <span v-else-if="scope.row.devicestatus == '1'" style="color: red">否</span>
            <span v-else style="color: green">是</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0 || scope.row.status == '0'" style="color: #909399">在库</span>
            <span v-else-if="scope.row.status == 1 || scope.row.status == '1'" style="color: chocolate">已出库</span>
            <span v-else-if="scope.row.status == 2 || scope.row.status == '2'" style="color: green">已归还</span>
            <span v-else-if="scope.row.status == 9 || scope.row.status == '9'" style="color: red">单据作废</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="viewMktLendRecord(scope.row)">借还记录</el-button>
            <el-button type="text" size="small" @click="viewMktUsageRecord(scope.row)">使用记录</el-button>
            <el-button type="text" size="small" @click="viewMktMaintenanceRecord(scope.row)">维护记录</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="borrowDetailShow = false">关 闭</el-button>
      </span>
    </el-dialog>

    <!-- 借还记录弹窗 -->
    <el-dialog :visible.sync="mktLendShow" title="借还记录" width="1000px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <el-descriptions :column="2" border>
        <el-descriptions-item label="出库人">{{
          mktLendForm.outUserText
        }}</el-descriptions-item>
        <el-descriptions-item label="出库时间">{{
          mktLendForm.outTime
        }}</el-descriptions-item>
        <el-descriptions-item label="出库照片" :span="2" v-if="mktLendForm.prePhotos">
          <el-image style="height: 100px" :src="getFullUrl(mktLendForm.prePhotos)"
            :preview-src-list="mktLendForm.prePhotoUrls"></el-image>
          <span style="margin-left: 10px">共{{
            mktLendForm.prePhotoUrls ? mktLendForm.prePhotoUrls.length : 0
            }}张</span>
        </el-descriptions-item>
        <el-descriptions-item label="出库备注" v-if="mktLendForm.remarkOut">
          {{ mktLendForm.remarkOut }}
        </el-descriptions-item>
        <el-descriptions-item label="入库人" v-if="mktLendForm.status == '2'">{{
          mktLendForm.inUserText
        }}</el-descriptions-item>
        <el-descriptions-item label="入库时间" v-if="mktLendForm.status == '2'">{{
          mktLendForm.inTime
        }}</el-descriptions-item>
        <el-descriptions-item label="入库照片" v-if="mktLendForm.status == '2' && mktLendForm.photoUrls">
          <el-image style="height: 100px" :src="getFullUrl(mktLendForm.photos)"
            :preview-src-list="mktLendForm.photoUrls"></el-image>
          <span style="margin-left: 10px">共{{ mktLendForm.photoUrls ? mktLendForm.photoUrls.length : 0 }}张</span>
        </el-descriptions-item>
        <el-descriptions-item label="入库签名" v-if="mktLendForm.status == '2' && mktLendForm.signPic">
          <el-image style="height: 100px" :src="getFullUrl(mktLendForm.signPic)"
            :preview-src-list="[getFullUrl(mktLendForm.signPic)]"></el-image>
        </el-descriptions-item>
        <el-descriptions-item label="入库备注" v-if="mktLendForm.status == '2' && mktLendForm.remark">
          {{ mktLendForm.remark }}
        </el-descriptions-item>
      </el-descriptions>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-left: 10px" type="info" @click="mktLendShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 使用记录弹窗 -->
    <el-dialog :visible.sync="mktUsageRecordShow" title="使用记录" width="1200px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="margin-bottom: 15px; display: flex; justify-content: flex-end;">
        <el-button type="success" size="small" @click="exportMktUsageRecord">导出</el-button>
      </div>
      <el-table :data="mktUsageRecordList" :header-cell-style="{ background: '#eff3f6' }" max-height="400"
        style="width: 100%">
        <el-table-column prop="useDate" label="使用日期" width="120" align="center"></el-table-column>
        <el-table-column prop="sampleName" label="样品名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sampleCode" label="样品编号" width="140" align="center"></el-table-column>
        <el-table-column label="开始时间" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.startTime ? scope.row.startTime.substring(0, 5) : '--' }}
          </template>
        </el-table-column>
        <el-table-column label="结束时间" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.endTime ? scope.row.endTime.substring(0, 5) : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="usePerson" label="使用人" width="100" align="center"></el-table-column>
        <el-table-column label="使用前状态" width="110" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.statusBeforeUse == 1" style="color: green">正常</span>
            <span v-else-if="scope.row.statusBeforeUse == 2" style="color: red">异常</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="使用后状态" width="110" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.statusAfterUse == 1" style="color: green">正常</span>
            <span v-else-if="scope.row.statusAfterUse == 2" style="color: red">异常</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="left" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="mktUsageRecordShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 维护记录弹窗 -->
    <el-dialog :visible.sync="mktMaintenanceRecordShow" title="维护记录" width="1100px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="margin-bottom: 15px; display: flex; justify-content: flex-end;">
        <el-button type="success" size="small" @click="exportMktMaintenanceRecord">导出</el-button>
      </div>
      <el-table :data="mktMaintenanceRecordList" :header-cell-style="{ background: '#eff3f6' }" max-height="400"
        style="width: 100%">
        <el-table-column prop="maintenanceTime" label="维护日期" width="120" align="center"></el-table-column>
        <el-table-column prop="maintenanceContent" label="维护内容" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="maintenancePerson" label="维护人" width="100" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="left" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="mktMaintenanceRecordShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 设备使用记录弹窗（按设备查询） -->
    <el-dialog :visible.sync="deviceUsageRecordShow" title="使用记录" width="1200px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="margin-bottom: 15px; display: flex; justify-content: flex-end;">
        <el-button type="success" size="small" @click="exportDeviceUsageRecord">导出</el-button>
      </div>
      <el-table :data="deviceUsageRecordList" :header-cell-style="{ background: '#eff3f6' }" max-height="400"
        style="width: 100%">
        <el-table-column prop="useDate" label="使用日期" width="120" align="center"></el-table-column>
        <el-table-column prop="sampleName" label="样品名称" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="sampleCode" label="样品编号" width="140" align="center"></el-table-column>
        <el-table-column label="开始时间" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.startTime ? scope.row.startTime.substring(0, 5) : '--' }}
          </template>
        </el-table-column>
        <el-table-column label="结束时间" width="100" align="center">
          <template slot-scope="scope">
            {{ scope.row.endTime ? scope.row.endTime.substring(0, 5) : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="usePerson" label="使用人" width="100" align="center"></el-table-column>
        <el-table-column label="使用前状态" width="110" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.statusBeforeUse == 1" style="color: green">正常</span>
            <span v-else-if="scope.row.statusBeforeUse == 2" style="color: red">异常</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="使用后状态" width="110" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.statusAfterUse == 1" style="color: green">正常</span>
            <span v-else-if="scope.row.statusAfterUse == 2" style="color: red">异常</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" align="left" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="deviceUsageRecordShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 设备维护记录弹窗（按设备查询） -->
    <el-dialog :visible.sync="deviceMaintenanceRecordShow" title="维护记录" width="1100px" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div style="margin-bottom: 15px; display: flex; justify-content: flex-end;">
        <el-button type="success" size="small" @click="exportDeviceMaintenanceRecord">导出</el-button>
      </div>
      <el-table :data="deviceMaintenanceRecordList" :header-cell-style="{ background: '#eff3f6' }" max-height="400"
        style="width: 100%">
        <el-table-column prop="maintenanceTime" label="维护日期" width="120" align="center"></el-table-column>
        <el-table-column prop="maintenanceContent" label="维护内容" align="left" show-overflow-tooltip></el-table-column>
        <el-table-column prop="maintenancePerson" label="维护人" width="100" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" align="left" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="deviceMaintenanceRecordShow = false">关闭</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import DeviceinfoCard from "./Deviceinfo_card.vue";
import deviceinfoCardPL from "./Deviceinfo_cardPL.vue";
import MultipleDevices from "../../components/common/MultipleDevices.vue";
import {
  assetCard,
  selectAllDeviceinfoInMarket,
  selectAllCompany,
  selectAllLable,
  deleteDeviceinfoByid,
  selectAllMajorType,
  selectAllProjectType,
  getStatueByDevice,
  selectAllDeviceType,
  mktProjectUnfinishedList,
  exportMarketDevice,
  shelvesChangeAdd,
  getTreeDeviceType,
  findByUserIdCompanyTree,
  selectArea,
  mktBorrowAdd,
  mktBorrowSubmit,
  mktBorrowView,
  mktBorrowUpdateDraft,
  selectShelves,
  transferOutMarket,
  exportAssetCard,
  mktInsertDevices,
  mktBorrowSelectDetailByDeviceId,
  mktBorrowViewDetail,
  mktUsageRecordListByBorrowId,
  mktUsageRecordExport,
  mktUsageRecordList,
  mktMaintenanceRecordListByDeviceId,
  mktMaintenanceRecordExport,
  mktMaintenanceRecordList,
  base,
} from "../../api/api";
import WeibaoApplyVue from "../../components/common/WeibaoApply.vue";
import baoFeiApplyVue from "../../components/common/BaoFeiApply.vue";
import DeviceCardbg from "./deviceCardbg.vue";
const docxPre = require("docx-preview");
window.JSZip = require("jszip");
export default {
  name: "Deviceinfo",
  components: {
    DeviceinfoCard,
    WeibaoApplyVue,
    baoFeiApplyVue,
    DeviceCardbg,
    deviceinfoCardPL,
    DC: MultipleDevices,
  },

  data() {
    return {
      props: {
        label: "deviceTypeName",
        value: "id",
        children: "deviceTypes",
        expandTrigger: "click",
        emitPath: false,
        checkStrictly: true, //设置可以单选一级
      },
      shelvesProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node;
          let nodes = [];
          selectShelves({ pid: value ? value : 0 }).then((datas) => {
            let { status, data } = datas;
            if (status == 200) {
              data.forEach((item) => {
                nodes.push({
                  label: item.name,
                  value: item.id,
                  leaf: item.deep == 3 ? true : false,
                });
              });
            }
            resolve(nodes);
          });
        },
      },
      propsAddress: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { value } = node;
          let nodes = [];
          selectArea({ pid: value ? value : 0 }).then((datas) => {
            let { status, data } = datas;
            if (status == 200) {
              data.forEach((item) => {
                nodes.push({
                  label: item.name,
                  value: item.id,
                  leaf: item.deep == 2 ? true : false,
                });
              });
            }
            resolve(nodes);
          });
        },
      },
      companyProps: {
        checkStrictly: true,
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,
      },
      excelForm: {
        deviceExcel: "",
      },
      userinfo: {},
      checkBoxNumber: 0,
      deviceCarddialog: false,
      deviceCarddialogbg: false,
      deviceCarddialogPL: false,
      deviceCarddialogbgPL: false,
      checkBoxdialog: false,
      importExcelDialog: false,
      checked: false,
      assetCardDialog: false,
      check: [],
      checkList: [],
      fileList: [],
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      deviceData: [],
      deviceDataDetail: [],
      deviceTable: [],
      searchModel: {
        search: "",
        deviceType: "",
        company: "",
        borrowStatus: "",
        zcmc: "",
        glbh: "",
      },
      otherChecked: false,
      deviceTypeSelect: [],
      companyData: [],
      companySelect: [],
      deviceTotalData: [],
      checkBoxData: [],
      deviceTypeData: [],
      xmflData: [],
      zyflData: [],
      deviceStatuData: [],
      btnRole: [],
      printObj: {
        id: "print", //id
        popTitle: "设备管理卡片", //自定义设置标题
        style: "margin-top:20px",
      },
      printAccet: {
        id: "printAsset", //id
        popTitle: "资产卡片", //自定义设置标题
        style: "margin-top:20px",
      },
      deviceinfoData: [],
      dialogTitle: "",
      dialogShow: false,
      showType: "",
      borrowDetailShow: false,
      borrowDetailList: [],
      // 借还记录弹窗
      mktLendShow: false,
      mktLendForm: {},
      // 使用记录弹窗
      mktUsageRecordShow: false,
      mktUsageRecordList: [],
      mktUsageRecordRow: {},
      // 维护记录弹窗
      mktMaintenanceRecordShow: false,
      mktMaintenanceRecordList: [],
      mktMaintenanceRecordRow: {},
      // 设备使用记录弹窗（按设备查询）
      deviceUsageRecordShow: false,
      deviceUsageRecordList: [],
      deviceUsageDeviceId: null,
      // 设备维护记录弹窗（按设备查询）
      deviceMaintenanceRecordShow: false,
      deviceMaintenanceRecordList: [],
      deviceMaintenanceDeviceId: null,
      // 上传中
      uploadBool: false,
      deviceinfoList: [],
      excelLoading: false,
      excelLoadingText: "立即上传",
      yjid: "",
      zyid: "",
      xmid: "",
      loading: false,
      loadingText: "",
      loadingInstance: null,
      borrowVisible: false,
      editingBorrowId: null, // 当前正在编辑的草稿 id（null=新增模式）
      borrowForm: {
        deviceList: [],
        deptName: null,
        addressDetail: null,
        addressName: null,
        addressIds: null,
        projectId: null,
        projectName: null,
        name: null,
        phone: null,
        address: null,
        persion: null,
        getType: "1",
        borrowDate: [],
      },
      datePickerOptions: {
        disabledDate(date) {
          // 禁用今天之前的日期
          return date.getTime() < Date.now() - 8.64e7;
        },
      },
      borrowRules: {
        deptName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        addressIds: [
          { required: true, message: "请选择所属区域", trigger: "blur" },
        ],
        addressDetail: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        borrowDate: [
          { required: true, message: "请输入借用日期", trigger: "blur" },
        ],
        getType: [
          { required: true, message: "请选择获取方式", trigger: "blur" },
        ],
        persion: [
          { required: true, message: "请输入委托人姓名", trigger: "blur" },
        ],
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        address: [
          { required: true, message: "请输入收件地址", trigger: "blur" },
        ],
      },
      questionForm: {
        deviceList: [],
      },
      dialogFormVisible: false,
      dialogFormVisible1: false,
      lable: {},
      changeShelvesVisible: false,
      changeShelvesForm: { row: {} },
      changeShelvesRules: {
        newIds: [{ required: true, message: "请选择新货架", trigger: "blur" }],
      },
      options: [],
      //划出设备超市
      toMarketShow: false,
      toMarketForm: {},
      toMarketRules: {
        bgr: [{ required: true, message: "请输入保管人", trigger: "blur" }],
        sydw: [{ required: true, message: "请选择使用部门", trigger: "blur" }],
      },
      showCards: false,
      exportIds: "",
    };
  },
  methods: {
    //查看借用详情
    viewBorrowDetail(row) {
      this.borrowDetailShow = true;
      this.borrowDetailList = [];
      mktBorrowSelectDetailByDeviceId({ deviceId: row.id }).then((res) => {
        if (res.status == 200 && res.data) {
          this.borrowDetailList = res.data.list || [];
        }
      });
    },
    // 获取完整图片URL
    getFullUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
      }
      return base + path;
    },
    // 查看借还记录
    viewMktLendRecord(row) {
      this.mktLendForm = {};
      this.mktLendShow = true;
      mktBorrowViewDetail(row.id).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          // 处理图片URL数组
          if (data.prePhotoUrls && Array.isArray(data.prePhotoUrls)) {
            data.prePhotoUrls = data.prePhotoUrls.map(url => this.getFullUrl(url));
          }
          if (data.photoUrls && Array.isArray(data.photoUrls)) {
            data.photoUrls = data.photoUrls.map(url => this.getFullUrl(url));
          }
          this.mktLendForm = data;
        } else {
          this.$message({
            message: message,
            type: 'error',
          });
        }
      });
    },
    // 查看使用记录
    viewMktUsageRecord(row) {
      this.mktUsageRecordRow = row;
      this.mktUsageRecordList = [];
      const borrowId = row.id;
      const deviceId = row.deviceId || row.id;
      mktUsageRecordListByBorrowId({ borrowId, deviceId }).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.mktUsageRecordList = data || [];
          this.mktUsageRecordShow = true;
        } else {
          this.$message({
            message: message || '获取使用记录失败',
            type: 'error',
          });
        }
      });
    },
    // 查看维护记录
    viewMktMaintenanceRecord(row) {
      this.mktMaintenanceRecordRow = row;
      this.mktMaintenanceRecordList = [];
      const borrowId = row.id;
      const deviceId = row.deviceId || row.id;
      mktMaintenanceRecordListByDeviceId(borrowId, deviceId).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.mktMaintenanceRecordList = (data && data.list) ? data.list : [];
          this.mktMaintenanceRecordShow = true;
        } else {
          this.$message({
            message: message || '获取维护记录失败',
            type: 'error',
          });
        }
      });
    },
    // 导出使用记录
    exportMktUsageRecord() {
      const borrowId = this.mktUsageRecordRow.id;
      const deviceId = this.mktUsageRecordRow.deviceId || this.mktUsageRecordRow.id;
      mktUsageRecordExport({ borrowId, deviceId }).then((res) => {
        if (res.status === 200) {
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = '设备使用记录.docx';
          link.click();
          window.URL.revokeObjectURL(url);
        } else {
          this.$message({ message: '导出失败', type: 'error' });
        }
      });
    },
    // 导出维护记录
    exportMktMaintenanceRecord() {
      const borrowId = this.mktMaintenanceRecordRow.id;
      const deviceId = this.mktMaintenanceRecordRow.deviceId || this.mktMaintenanceRecordRow.id;
      mktMaintenanceRecordExport({ borrowId, deviceId }).then((res) => {
        if (res.status === 200) {
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = '设备维护记录.docx';
          link.click();
          window.URL.revokeObjectURL(url);
        } else {
          this.$message({ message: '导出失败', type: 'error' });
        }
      });
    },
    // 查看设备使用记录（按设备查询）
    viewDeviceUsageRecord(row) {
      this.deviceUsageDeviceId = row.id;
      this.deviceUsageRecordList = [];
      mktUsageRecordList({ deviceId: row.id }).then((res) => {
        if (res.status == 200 && res.data) {
          this.deviceUsageRecordList = res.data || [];
          this.deviceUsageRecordShow = true;
        } else {
          this.$message({ message: res.message || '获取使用记录失败', type: 'error' });
        }
      });
    },
    // 导出设备使用记录
    exportDeviceUsageRecord() {
      mktUsageRecordExport({ deviceId: this.deviceUsageDeviceId }).then((res) => {
        if (res.status === 200) {
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = '设备使用记录.docx';
          link.click();
          window.URL.revokeObjectURL(url);
        } else {
          this.$message({ message: '导出失败', type: 'error' });
        }
      });
    },
    // 查看设备维护记录（按设备查询）
    viewDeviceMaintenanceRecord(row) {
      this.deviceMaintenanceDeviceId = row.id;
      this.deviceMaintenanceRecordList = [];
      mktMaintenanceRecordList({ deviceId: row.id, pageIndex: 1, pageSize: 1000 }).then((res) => {
        if (res.status == 200 && res.data) {
          this.deviceMaintenanceRecordList = (res.data && res.data.list) ? res.data.list : [];
          this.deviceMaintenanceRecordShow = true;
        } else {
          this.$message({ message: res.message || '获取维护记录失败', type: 'error' });
        }
      });
    },
    // 导出设备维护记录
    exportDeviceMaintenanceRecord() {
      mktMaintenanceRecordExport({ deviceId: this.deviceMaintenanceDeviceId }).then((res) => {
        if (res.status === 200) {
          const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = '设备维护记录.docx';
          link.click();
          window.URL.revokeObjectURL(url);
        } else {
          this.$message({ message: '导出失败', type: 'error' });
        }
      });
    },
    //获取项目选项
    getOptions() {
      let pageIndex = this.pageIndex;
      let pageSize = 10000;
      mktProjectUnfinishedList({ pageIndex, pageSize }).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          //转换
          for (let i in data.list) {
            (data.list[i].label = data.list[i].projectName),
              (data.list[i].value = data.list[i].id);
            this.options.push(data.list[i]);
          }
        } else {
          this.$message({
            message: message,
            type: "error",
          });
        }
      });
    },
    //选择项目
    selectProject(e) {
      for (let i in this.options) {
        if (this.options[i].id == e) {
          this.borrowForm.projectId = e;
          this.borrowForm.addressDetail = this.options[i].addressDetail;
          this.borrowForm.addressName = this.options[i].addressName;
          this.borrowForm.addressIds = [0, 0, this.options[i].addressId];
          return;
        }
      }
      this.$nextTick(() => {
        this.$refs.cascader.$refs.panel.clearCheckedNodes();
        this.$refs.cascader.$refs.panel.activePath = [];
      });
    },
    //输入其他项目名称
    otherChange(e) {
      this.borrowForm.projectName = null;
      this.borrowForm.addressIds = null;
      this.borrowForm.addressDetail = null;
      this.borrowForm.addressName = null;
      this.borrowForm.projectId = null;
      this.$nextTick(() => {
        this.$refs.cascader.clearCheckedNodes();
      });
    },
    //隐藏地址选择下拉
    handleCascaderChange() {
      this.$refs.cascader.dropDownVisible = false;
    },
    handleCascader2Change() {
      this.$refs.cascader2.dropDownVisible = false;
    },
    //申请接入
    borrowHandle() {
      // 默认选中当天
      const today = new Date();
      const todayStr = this.formatDate(today);
      this.borrowForm.borrowDate = [todayStr, todayStr];
      this.borrowVisible = true;
    },
    // 格式化日期
    formatDate(date) {
      const year = date.getFullYear();
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const day = date.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    resetData() {
      this.$nextTick(() => {
        this.borrowForm = { deviceList: [] };
      });
    },
    //设备借用取消
    borrowCancel() {
      this.borrowVisible = false;
      this.editingBorrowId = null;
      this.resetData();
    },
    //保存草稿：新增模式调 add，编辑模式调 updateDraft
    saveDraft() {
      if (
        !this.borrowForm.deviceList ||
        this.borrowForm.deviceList.length === 0
      ) {
        this.$message({
          message: "至少选择一个资产",
          type: "error",
        });
        return;
      }
      // 校验结束日期必须大于开始日期
      if (this.borrowForm.borrowDate && this.borrowForm.borrowDate.length === 2) {
        const startDate = new Date(this.borrowForm.borrowDate[0]);
        const endDate = new Date(this.borrowForm.borrowDate[1]);
        if (endDate < startDate) {
          this.$message({
            message: "结束日期必须大于开始日期",
            type: "error",
          });
          return;
        }
      }
      this.$refs.borrowForm.validate((valid) => {
        if (!valid) {
          console.log("验证失败!");
          return false;
        }
        // 编辑模式：调 updateDraft；新增模式：调 add
        const api = this.editingBorrowId ? mktBorrowUpdateDraft : mktBorrowAdd;
        const params = this.editingBorrowId
          ? { ...this.borrowForm, id: this.editingBorrowId }
          : this.borrowForm;
        api(params).then((datas) => {
          let { status, message } = datas;
          if (status == 200) {
            this.$message({
              message: "草稿已保存",
              type: "success",
            });
            this.borrowVisible = false;
            this.editingBorrowId = null;
            this.resetData();
            this.$router.push({
              path: "MktRecord",
            });
          } else {
            this.$message({
              message: message,
              type: "error",
            });
          }
        });
      });
    },

    //提交审核：编辑模式 updateDraft+submit；新增模式 add+submit
    submitAudit() {
      if (
        !this.borrowForm.deviceList ||
        this.borrowForm.deviceList.length === 0
      ) {
        this.$message({
          message: "至少选择一个资产",
          type: "error",
        });
        return;
      }
      // 校验结束日期必须大于开始日期
      if (this.borrowForm.borrowDate && this.borrowForm.borrowDate.length === 2) {
        const startDate = new Date(this.borrowForm.borrowDate[0]);
        const endDate = new Date(this.borrowForm.borrowDate[1]);
        if (endDate < startDate) {
          this.$message({
            message: "结束日期必须大于开始日期",
            type: "error",
          });
          return;
        }
      }
      this.$refs.borrowForm.validate((valid) => {
        if (!valid) {
          console.log("验证失败!");
          return false;
        }
        // 二次确认：提交后进入审核
        this.$confirm(
          "提交后将进入审核。确定要提交吗？",
          "提示",
          {
            confirmButtonText: "确认提交",
            cancelButtonText: "再想想",
            type: "warning",
          }
        ).then(() => {
          // 编辑模式：先 updateDraft 拿原 id；新增模式：先 add 拿 id
          const saveApi = this.editingBorrowId ? mktBorrowUpdateDraft : mktBorrowAdd;
          const params = this.editingBorrowId
            ? { ...this.borrowForm, id: this.editingBorrowId }
            : this.borrowForm;
          saveApi(params).then((datas) => {
            let { status, message, data } = datas;
            if (status != 200) {
              this.$message({ message: message || "提交失败", type: "error" });
              return;
            }
            const borrowId = this.editingBorrowId || data;
            // 第二步：submit 锁定设备
            mktBorrowSubmit({ id: borrowId }).then((res) => {
              if (res.status == 200) {
                this.$message({ message: "提交成功", type: "success" });
                this.borrowVisible = false;
                this.editingBorrowId = null;
                this.resetData();
                this.$router.push({ path: "MktRecord" });
              } else {
                this.$message({ message: res.message || "提交失败", type: "error" });
              }
            });
          });
        }).catch(() => {});
      });
    },
    // 单元格样式
    tableCellStyle({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#b7e0ff;padding:0px;border-color: #000000;border-top:#000000; ";
      }
      if (rowIndex === 3) {
        return "padding:0px;border-color: #000000;border-top:#000000";
      }
      return "border-color: #000000;padding:1px;border-left:#000000";
    },
    // 合并单元格
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if (columnIndex === 0) {
          return {
            rowspan: 1,
            colspan: 4,
          };
          // return [1, 4];
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (rowIndex === 1) {
        if (columnIndex === 1) {
          return {
            rowspan: 1,
            colspan: 4,
          };
        } else if (columnIndex != 1 && columnIndex != 0) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (
        rowIndex === 2 ||
        rowIndex === 3 ||
        rowIndex === 4 ||
        rowIndex === 5 ||
        rowIndex === 6
      ) {
        if (columnIndex === 1) {
          return {
            rowspan: 1,
            colspan: 2,
          };
        } else if (columnIndex != 0 && columnIndex != 2) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
      if (columnIndex === 2) {
        if (rowIndex === 2) {
          return {
            rowspan: 5,
            colspan: 1,
          };
        } else if (rowIndex != 7) {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    getRowKeys(row) {
      return row.id;
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      sessionStorage.setItem("pageIndex", val);
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.getDeviceinfo();
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getDeviceinfo();
    },
    //获取label不为id的label加在checkList里面
    getCheckList() {
      // debugger
      for (var i = 0; i < this.deviceTable.length; i++) {
        let id = "id";
        if (this.deviceTable[i].label.indexOf(id) < 0) {
          this.checkList.push(this.deviceTable[i].label);
        }
      }
    },
    //获取ispass为true的加载check里面
    getCheck() {
      for (var i = 0; i < this.deviceTable.length; i++) {
        // debugger
        let id = "id";
        if (this.deviceTable[i].label.indexOf(id) < 0) {
          if (this.deviceTable[i].ispass.indexOf("true") >= 0) {
            // debugger
            this.check.push(this.deviceTable[i].label);
          }
        }
      }
    },
    //查询所有label
    selectAllLables() {
      selectAllLable().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          sessionStorage.setItem("deviceinfoLable", JSON.stringify(data));
          // debugger
          for (var i = 0; i < data.length; i++) {
            if (
              data[i].showPostion == 1 ||
              data[i].showPostion == 4 ||
              data[i].showPostion == 5
            ) {
              this.deviceTable.push(data[i]);
            }
          }
          this.getCheckList();
          this.getCheck();
        }
      });
    },
    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var companyCode = "";
      if (
        userinfo.userRole == 1 ||
        (userinfo.fjqx != null &&
          (userinfo.fjqx.indexOf("3") != -1 ||
            userinfo.fjqx.indexOf("4") != -1))
      ) {
        companyCode = "-1";
      } else {
        companyCode = userinfo.companyCode;
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.companySelect = this.getCompanyTreeData(data);
        }
      });
    },
    //删除信息
    deleteClick(row) {
      this.borrowForm.deviceList.splice(
        this.borrowForm.deviceList.indexOf(row),
        1
      );
    },

    getCompanyTreeData(companyData) {
      for (let i = 0; i < companyData.length; i++) {
        if (companyData[i].zcompany.length > 0) {
          // children不为空时继续调用该方法
          this.getCompanyTreeData(companyData[i].zcompany);
        } else {
          // 最后一级没有数据将children变成undefined
          companyData[i].zcompany = undefined;
        }
      }
      return companyData;
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].deviceTypes.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].deviceTypes = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].deviceTypes);
        }
      }
      return data;
    },
    //查询所有分类数据
    getfenleiData() {
      //查找设备状态
      let _this = this;
      getStatueByDevice().then((datas) => {
        let { status, data } = datas;

        if (status == 200) {
          // this.deviceStatuData=data
          for (var i = 0; i < data.length; i++) {
            // if (data[i].statusName.indexOf('待审核') == -1) {
            _this.deviceStatuData.push(data[i]);
            // }
          }

          sessionStorage.setItem(
            "deviceStatuData",
            JSON.stringify(_this.deviceStatuData)
          );
        }
      });
      selectAllCompany().then((resultData) => {
        let { status, data } = resultData;
        if (status == 200) {
          this.companyData = data;
        }
      });

      // //查找单位
      // selectAllCompany().then(datas => {
      //     let { status, data } = datas
      //     if (status == 200) {
      //         for (var i = 0; i < data.length; i++) {

      //         }

      //     }
      // })
      // 查找设备类型
      selectAllDeviceType().then((datas) => {
        let { status, data } = datas;
        if (status == 200) {
          sessionStorage.setItem("deviceTypeData", JSON.stringify(data));
          this.deviceTypeData = data;
          // this.deviceTypeSelect.push({ label: "所有设备", value: "所有设备" })
          // for (var i = 0; i < data.length; i++) {
          //     if (data[i].pid != "P") {
          //         this.deviceTypeSelect.push({ label: data[i].deviceTypeName, value: data[i].deviceTypeCode + "-" + data[i].pid })
          //     }
          // }
        }
      });

      let _parmas = {
        userId: JSON.parse(localStorage.getItem("user")).userId,
      };

      getTreeDeviceType(_parmas).then((datas) => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          _this.deviceTypeSelect = this.getTreeData(data);
          // debugger
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
      //查找专业
      selectAllMajorType().then((datas) => {
        let { status, data } = datas;
        if (status == 200) {
          this.zyflData = data;
          sessionStorage.setItem("zyflData", JSON.stringify(data));
        }
      });

      selectAllProjectType().then((datas) => {
        let { status, data } = datas;
        if (status == 200) {
          this.xmflData = data;
          sessionStorage.setItem("xmflData", JSON.stringify(data));
        }
      });
    },
    //选择资产
    transferValue(outData) {
      // this.questionForm = outData;
      var list = [];
      for (var i = 0; i < outData.length; i++) {
        list.push(outData[i]);
      }
      this.$set(this.borrowForm, `deviceList`, list);
    },
    //查找设备信息
    getDeviceinfo() {
      // if (this.searchModel.deviceType != "所有设备") {
      //     if (this.searchModel.deviceType != "" || this.searchModel.deviceType != null) {
      //         yjfl = this.searchModel.deviceType.split("-")[1]
      //         ejfl = this.searchModel.deviceType.split("-")[0]
      //     }
      // }
      if (
        sessionStorage.getItem("update") == "true" ||
        sessionStorage.getItem("detail") == "true"
      ) {
        if (sessionStorage.getItem("pageIndex") != undefined) {
          this.pageIndex = sessionStorage.getItem("pageIndex") * 1;
          if (sessionStorage.getItem("detail") == "true") {
            sessionStorage.setItem("detail", false);
          }
          if (sessionStorage.getItem("update") == "true") {
            sessionStorage.setItem("update", false);
          }
        }
      }
      let _params = {
        content: this.searchModel.search,
        ejfl: this.searchModel.deviceType,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        sydw: this.searchModel.company,
        userId: JSON.parse(localStorage.getItem("user")).userId,
        borrowStatus: this.searchModel.borrowStatus,
        zcmc: this.searchModel.zcmc,
        glbh: this.searchModel.glbh,
      };
      selectAllDeviceinfoInMarket(_params).then((datas) => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.deviceData = data.list;
          // this.deviceData = this.deviceTotalData.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
          this.total = data.total;
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    //模糊搜索查找设备信息
    searchDeviceinfo() {
      this.deviceData = [];
      this.deviceTotalData = [];
      this.pageIndex = 1;
      if (
        sessionStorage.getItem("update") == "true" ||
        sessionStorage.getItem("detail") == "true"
      ) {
        if (sessionStorage.getItem("pageIndex") != undefined) {
          this.pageIndex = sessionStorage.getItem("pageIndex") * 1;
          if (sessionStorage.getItem("detail") == "true") {
            sessionStorage.setItem("detail", false);
          }
          if (sessionStorage.getItem("update") == "true") {
            sessionStorage.setItem("update", false);
          }
        }
      }
      let _params = {
        content: this.searchModel.search,
        ejfl: this.searchModel.deviceType,
        pageIndex: this.pageIndex,
        pageSize: this.pagesize,
        sydw: this.searchModel.company,
        userId: JSON.parse(localStorage.getItem("user")).userId,
        borrowStatus: this.searchModel.borrowStatus,
        zcmc: this.searchModel.zcmc,
        glbh: this.searchModel.glbh,
      };
      selectAllDeviceinfoInMarket(_params).then((datas) => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          // debugger
          if (data.length != 0) {
            this.deviceTotalData = data;
            this.deviceData = data.list;
          }
          // this.deviceData = this.deviceTotalData.slice((this.pageIndex - 1) * this.pagesize, this.pageIndex * this.pagesize)
          this.total = data.total;
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    // 跳转至设备详情页面
    toDetail(data) {
      sessionStorage.setItem("deviceinfoDetail", JSON.stringify(data));
      sessionStorage.setItem("from", "detail");
      sessionStorage.setItem("detail", true);
      sessionStorage.setItem("examineResult", "");

      //添加路由跳转至查看设备
      this.$router.push({
        path: "DeviceDetailOnly",
      });
    },
    // 获取复选框选中数据
    changeCheckBoxValue(val) {
      this.checkBoxData = val;
      this.checkBoxNumber = this.checkBoxData.length;
      // $.each(val,function(i,v){
      //     debugger
      //     this.checkBoxData.push(v);
      // })
    },
    // 清空所有内容
    removeAllCheckbox() {
      this.checkBoxData = [];
      this.checkBoxNumber = this.checkBoxData.length;
      this.$refs.deviceTable.clearSelection(); //清除所有选中复选框
      this.checkBoxdialog = false;
    },
    // 移除一条选中内容
    removeThisData(row) {
      let newCheckBoxData = [];
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].id != row.id) {
          // debugger
          newCheckBoxData.push(this.checkBoxData[i]);
        }
      }
      this.checkBoxData = newCheckBoxData;
      if (this.checkBoxData.length > 0) {
        this.$refs.deviceTable.store.states.selection.map((item, index) => {
          if (item.id === row.id) {
            this.$refs.deviceTable.store.states.selection.splice(index, 1);
          }
        });
      } else {
        this.$refs.deviceTable.clearSelection(); //清除所有选中复选框
        this.checkBoxdialog = false;
      }
      this.checkBoxNumber = this.checkBoxData.length;
    },
    // 点击删除按钮判断是否选中有复选框
    clickDeleteBtn() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
      } else {
        // this.dialogDelete=true
        let deleteData = this.checkBoxData.map((item) => item.id).join();
        this.deleteComit(deleteData);
      }
    },
    // 点击编辑按钮
    clickUpdateBtn() {
      if (this.checkBoxData.length != 1) {
        this.$message({
          message: "请选择一条数据",
          type: "warning",
        });
      } else {
        sessionStorage.setItem(
          "deviceUpdate",
          JSON.stringify(this.checkBoxData)
        );
        sessionStorage.setItem("update", true);
        sessionStorage.setItem("examineResult", "other");
        //添加路由跳转至修改设备
        this.$router.push({
          path: "deviceinfoUpdate",
        });
      }
    },
    // 点击删除按钮后调用
    deleteComit(data) {
      this.$confirm("确定删除已选择设备吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let _params = {
          id: data,
          userId: JSON.parse(localStorage.getItem("user")).userId,
        };
        deleteDeviceinfoByid(_params).then((datas) => {
          let { message, status } = datas;
          if (status == 200) {
            this.$message({ message: "删除成功", type: "success" });
            this.removeAllCheckbox();
            this.getDeviceinfo();
          } else {
            this.$message({ message: "删除失败", type: "error" });
          }
        });
      });
    },
    // 格式化一级分类列
    formateYjfl(row, colum) {
      let yjfl = "";
      for (var i = 0; i < this.deviceTypeData.length; i++) {
        if (this.deviceTypeData[i].id.indexOf(row.yjfl) != -1) {
          yjfl = this.deviceTypeData[i].deviceTypeName;
          return yjfl;
        }
      }
    },
    // 格式化二级分类列
    formateEjfl(row, colum) {
      let ejfl = "";
      for (var i = 0; i < this.deviceTypeData.length; i++) {
        if (row.ejfl == this.deviceTypeData[i].id) {
          ejfl = this.deviceTypeData[i].deviceTypeName;
          return ejfl;
        }
      }
    },
    // 格式化专业分类列
    formateZyfl(row, colum) {
      let zyfl = "";
      for (var i = 0; i < this.zyflData.length; i++) {
        if (row.zyfl == this.zyflData[i].id) {
          zyfl = this.zyflData[i].name;
          return zyfl;
        }
      }
    },
    // 格式化项目分类列
    formateXmfl(row, colum) {
      let xmfl = "";
      for (var i = 0; i < this.xmflData.length; i++) {
        if (row.xmfl == this.xmflData[i].id) {
          if (row.zyfl == this.xmflData[i].mId) {
            xmfl = this.xmflData[i].name;
            return xmfl;
          }
        }
      }
    },
    // 跳转至添加页面
    toDeviceinAdd() {
      this.$router.push({
        path: "deviceinfoAdd",
        query: { fromMarket: "1" },
      });
    },
    // 开启loading
    // 数据导出到excel
    export2Excel() {
      let _this = this;
      let ids = "";
      if (this.checkBoxData.length > 0) {
        ids = this.checkBoxData.map((item) => item.id).join();
      }
      this.loadingUtil.showLoading("正在下载中，请稍后……");

      let _params = {
        content: this.searchModel.search,
        ejfl: this.searchModel.deviceType,
        sydw: this.searchModel.company,
        userId: JSON.parse(localStorage.getItem("user")).userId,
        id: ids,
      };
      exportMarketDevice(_params).then((resultData) => {
        const blob = new Blob([resultData]);
        const dlink = document.createElement("a");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const dlink = document.createElement("a");
          dlink.download = "设备超市档案信息.xlsx";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href); // 释放URL 对象
          document.body.removeChild(dlink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, "设备超市档案信息.xlsx");
        }
        _this.loadingUtil.hideLoading();
      });
    },
    /**
     * 变更货架
     */
    changeShelvesHandle() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "请选择一台设备",
          type: "warning",
        });
      } else if (this.checkBoxData.length > 1) {
        this.$message({
          message: "最多只能选择一台设备",
          type: "warning",
        });
      } else {
        this.changeShelvesForm.row = this.checkBoxData[0];
        this.changeShelvesForm.deviceId = this.checkBoxData[0].id;
        this.changeShelvesVisible = true;
      }
    },
    changeShelvesOk() {
      this.$refs.changeShelvesForm.validate((valid) => {
        if (valid) {
          shelvesChangeAdd(this.changeShelvesForm).then((datas) => {
            let { status, message } = datas;
            if (status == 200) {
              this.$message({
                message: message,
                type: "success",
              });
              this.changeShelvesVisible = false;
              this.changeShelvesForm = { row: {} };
              this.removeAllCheckbox();
              this.getDeviceinfo();
            } else {
              this.$message({
                message: message,
                type: "error",
              });
            }
          });
          this.borrowVisible = false;
        } else {
          console.log("验证失败!");
          return false;
        }
      });
    },
    //借用申请
    applyBorrowing() {
      this.editingBorrowId = null;
      this.borrowVisible = true;
    },

    //打开编辑草稿弹窗：拉取草稿数据 → 回填表单 → 打开弹窗
    openBorrowDialogForEdit(borrowId) {
      mktBorrowView(borrowId).then((datas) => {
        let { status, message, data } = datas;
        if (status != 200 || !data) {
          this.$message({ message: message || "加载草稿失败", type: "error" });
          return;
        }
        // 校验状态：只有草稿（"4"）才能编辑
        if (String(data.status) !== "4") {
          this.$message({ message: "只有草稿状态可以编辑", type: "warning" });
          return;
        }
        // 回填表单
        const today = new Date();
        const todayStr = this.formatDate(today);
        this.borrowForm = {
          deviceList: (data.detailList || []).map(d => d.deviceinfo).filter(Boolean),
          deptName: data.deptName || null,
          addressDetail: data.addressDetail || null,
          addressName: data.addressName || null,
          addressIds: data.addressId ? [0, 0, data.addressId] : null,
          projectId: data.projectId || null,
          projectName: data.projectName || null,
          name: data.name || null,
          phone: data.phone || null,
          address: data.address || null,
          persion: data.persion || null,
          getType: data.getType || "1",
          borrowDate: [data.borrowDateStart || todayStr, data.borrowDateEnd || todayStr],
        };
        this.editingBorrowId = data.id;
        this.borrowVisible = true;
        // 提示用户有设备被借走
        const lockedDevices = (data.detailList || [])
          .map(d => d.deviceinfo)
          .filter(d => d && d.borrowStatus !== "0" && d.borrowStatus !== 0);
        if (lockedDevices.length > 0) {
          const names = lockedDevices.map(d => `${d.zcmc}（${d.glbh}）`).join("、");
          this.$alert(
            `您草稿中的以下设备已被借出：\n${names}\n\n请重新选择其他设备后再提交。`,
            "提示",
            { confirmButtonText: "我知道了" }
          );
        }
      }).catch((err) => {
        console.error("加载草稿失败", err);
        this.$message({ message: "加载草稿失败", type: "error" });
      });
    },
    selectDeviceCardClick() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "请至少选择一台设备",
          type: "warning",
        });
      } else {
        this.deviceDataDetail = this.checkBoxData;
        // console.log(this.deviceDataDetail)
        var jc = [];
        var bg = [];
        this.deviceDataDetail.forEach((item) => {
          if (item.yjfl == "P0001") {
            bg.push(item);
          }
          if (item.yjfl == "P0002") {
            jc.push(item);
          }
        });
        if (bg.length != 0) {
          this.deviceCarddialogbgPL = true;
          this.showType = "办公设备";
          this.$nextTick(() => this.$refs.selectBanGongCard.setTableData());
        }
        if (jc.length != 0) {
          this.deviceCarddialogPL = true;
          this.showType = "检测设备";
          this.$nextTick(() => this.$refs.selectJianceCard.setTableData());
        }
      }
    },
    //划出设备超市
    outMarket() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "请至少选择一台设备",
          type: "warning",
        });
        return;
      }
      // 设置默认选中部门
      this.setDefaultCompany();
      this.toMarketShow = true;
    },
    // 设置默认选中的部门
    setDefaultCompany() {
      if (!this.companySelect || this.companySelect.length === 0) {
        return;
      }
      // 优先选择指定的部门 G118016
      const targetCompany = this.findCompanyByCode(this.companySelect, "G118016");
      if (targetCompany) {
        this.toMarketForm.sydw = targetCompany.companyCode;
        return;
      }
      // 获取当前用户信息
      const userinfo = this.userinfo || JSON.parse(localStorage.getItem("user"));
      // 如果用户有特定的部门代码，优先选择用户所属部门
      if (userinfo && userinfo.companyCode && userinfo.companyCode !== "G065" && userinfo.userRole !== 1) {
        // 在companySelect中查找用户所属的部门
        const userCompany = this.findCompanyByCode(this.companySelect, userinfo.companyCode);
        if (userCompany) {
          this.toMarketForm.sydw = userCompany.companyCode;
          return;
        }
      }
      // 如果没有找到指定部门或用户部门，默认选择第一个可用部门
      this.toMarketForm.sydw = this.companySelect[0].companyCode;
    },
    // 递归查找指定代码的公司/部门
    findCompanyByCode(companies, targetCode) {
      for (let i = 0; i < companies.length; i++) {
        const company = companies[i];
        // 检查当前节点
        if (company.companyCode === targetCode) {
          return company;
        }
        // 递归检查子节点
        if (company.zcompany && company.zcompany.length > 0) {
          const found = this.findCompanyByCode(company.zcompany, targetCode);
          if (found) {
            return found;
          }
        }
      }
      return null;
    },
    outMarketOk() {
      this.$confirm("确将该设备划出设备超市吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.toMarketForm.ids = this.checkBoxData.map((item) => item.id);
        transferOutMarket(this.toMarketForm).then((datas) => {
          let { message, status } = datas;
          if (status == 200) {
            this.$message({ message: "划出成功", type: "success" });
            this.removeAllCheckbox();
            this.getDeviceinfo();
            this.toMarketShow = false;
            this.toMarketForm = {};
          } else {
            this.$message({ message: message, type: "error" });
          }
        })
      });
    },
    // 下载资产卡片
    downloadAssetCard() {
      let deviceData = [];
      deviceData = this.checkBoxData[0];
      // assetCard(deviceData).then(datas => {
      //     let blob = new Blob([datas], { type: "docx" })

      // })
      assetCard(deviceData).then((resultData) => {
        const blob = new Blob([resultData]);
        const dlink = document.createElement("a");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const dlink = document.createElement("a");
          dlink.download = this.checkBoxData[0].zcmc + "-资产卡片.docx";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href); // 释放URL 对象
          document.body.removeChild(dlink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(
            blob,
            this.checkBoxData[0].zcmc + "-资产卡片.docx"
          );
        }
        // _this.loadingUtil.hideLoading()
      });
    },
    // switch开关改变事件
    switchChange(val, row) {
      let actionType = val === true ? "used" : "diaoBo";
      // let deviceId = this.checkBoxData.map(item => item.id).join()
      let _params = {
        actionType: actionType,
        id: row.id,
      };
      // usedOrDiaoBo(_params).then(datas=>{
      //     let {status,message}=datas
      //     if(status==200){
      //         this.$message({
      //             message: message,
      //             type: 'success'
      //         });
      //     }else{
      //         this.$message({
      //             message: message,
      //             type: 'error'
      //         });
      //     }
      // })
    },
    // 格式化使用年限
    formateUseTime(row) {
      let buyDate = new Date(row.cgrq);
      let nowDate = new Date();
      let userTime = nowDate.getTime() - buyDate.getTime();
      let useYear = userTime / 1000 / 60 / 60 / 24 / 365;
      if (useYear < 1) {
        return 1;
      } else {
        if (!isNaN(useYear)) {
          return Math.floor(useYear);
        }
      }
      // let year = nowData.getFullYear();
      // let month = (nowData.getMonth() + 1).toString().padStart(2, '0');
      // let date = nowData.getDate().toString().padStart(2, '0');
      // return `${year}-${month}-${date}`;
    },
    // 定义方法关闭dialog对话框
    isShow() {
      this.dialogShow = false;
    },
    // 点击设备卡片

    // 监听对话框关闭，清除里面的数据
    closeDialog() {
      if (this.showType == "维保") {
        this.$refs.weibaoApply.questionForm.reason = "";
        this.$refs.weibaoApply.questionForm.maintenanceType = "";
        this.removeAllCheckbox();
      }
      if (this.showType == "报废") {
        this.$refs.baoFeiApply.questionForm.reason = "";
        this.removeAllCheckbox();
      }
      // if (this.showType == '检测设备') {
      //     debugger
      //     this.$refs.jianceCard.deviceinfoData = []
      //     this.$refs.jianceCard.deviceinfoData.push({
      //         prop1: "设备管理卡片"
      //     }, {
      //         prop1: "资产名称",
      //         prop2: ""
      //     }, {
      //         prop1: "设备型号",
      //         prop2: "",
      //         prop3: "",
      //     }, {
      //         prop1: "生产厂家",
      //         prop2: ""
      //     }, {
      //         prop1: "出厂编号",
      //         prop2: ""
      //     }, {
      //         prop1: "规格型号",
      //         prop2: ""
      //     }, {
      //         prop1: "购置日期",
      //         prop2: ""
      //     }, {
      //         prop1: "所属部门",
      //         prop2: "",
      //         prop3: "保管人",
      //         prop4: "",
      //     })
      // }
    },
    // 导出设备卡片（PDF预览）
    deviceCardsClick() {
      this.exportIds = this.checkBoxData.map((item) => item.id).join(",");
      this.showCards = true;
    },
    // 点击资产卡片按钮
    assetCardClick() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "请选择一台设备",
          type: "warning",
        });
      } else if (this.checkBoxData.length > 1) {
        this.$message({
          message: "最多只能选择一台设备",
          type: "warning",
        });
      } else {
        let that = this;
        let deviceData = [];
        deviceData = this.checkBoxData[0];
        delete deviceData.aqjdUrls;
        assetCard(deviceData).then((datas) => {
          let blob = new Blob([datas], { type: "docx" });
          docxPre.renderAsync(blob, that.$refs.docxView);
        });
        this.assetCardDialog = true;
      }
    },
    // 点击申请维保
    clickWeiBao() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
      } else {
        this.dialogTitle = "申请维保";
        this.dialogShow = true;
        this.showType = "维保";
      }
    },
    // 点击申请报废
    clickBaoFei() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
      } else {
        this.dialogTitle = "申请报废";
        this.dialogShow = true;
        this.showType = "报废";
      }
    },
    // 点击检定录入
    clickCheck() {
      this.$router.push({
        path: "verification",
      });
    },
    // 导出资产卡片
    exportAssetCardClick() {
      if (this.checkBoxData.length <= 0) {
        this.$message({
          message: "至少选择一条数据",
          type: "warning",
        });
        return;
      }
      let _this = this;
      let ids = "";
      if (this.checkBoxData.length > 0) {
        ids = this.checkBoxData.map((item) => item.id).join();
      }
      this.loadingUtil.showLoading("正在下载中，请稍后……");

      let _params = {
        content: this.searchModel.search,
        ejfl: this.searchModel.deviceType,
        sydw: this.searchModel.company,
        userId: JSON.parse(localStorage.getItem("user")).userId,
        id: ids,
      };
      exportAssetCard(_params).then((resultData) => {
        const blob = new Blob([resultData]);
        const dlink = document.createElement("a");
        if ("download" in document.createElement("a")) {
          dlink.download = "资产卡片.docx";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href);
          document.body.removeChild(dlink);
        } else {
          navigator.msSaveBlob(blob, "资产卡片.docx");
        }
        _this.loadingUtil.hideLoading();
      });
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleChange(file, fileList) {
      this.file = file;
      this.fileList = fileList;
      this.uploadBool = false;
      this.fileTemp = file.raw;
      let reader = new FileReader();

      // 判断上传文件格式
      if (this.fileTemp) {
        // if ((this.fileTemp.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') || (this.fileTemp.type == 'application/vnd.ms-excel')) {
        this.importfxx(this.fileTemp);
        // } else {
        //     this.$message({
        //         type: 'warning',
        //         message: '附件格式错误，请删除后重新上传！'
        //     })
        // }
      }
    },
    uploadFile(file) {
      // this.insertFormData.append("file", file.file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length
        } 个文件`
      );
    },
    beforeUpload(file) {
      // const isPdf = file.type === 'application/pdf';
      // if (!isPdf) {
      // 	this.$message.error('仅支持 pdf 格式!');
      // }
      // return isPdf
      this.uploadBool = true;
    },
    download() {
      window.open(base + '/deviceinfo/downloadTemplateFile?fileName=deviceinfo.xlsx');
    },
    closeExcelDialog() {
      this.fileList = [];
    },
    clickUpload() {
      if (this.fileList.length == 0) {
        this.$message({
          message: "请选择文件",
          type: "warning",
        });
      } else if (this.deviceinfoList.length == 0) {
        this.$message({
          message: "请勿上传空文件",
          type: "warning",
        });
      } else {
        let companyNames = [];
        let deviceTypeNames = [];
        let projectTypeNames = [];
        let deviceStatus = [];
        let isTrue = true;
        for (var j = 0; j < this.companyData.length; j++) {
          companyNames.push(this.companyData[j].companyName);
        }
        for (var i = 0; i < this.deviceTypeData.length; i++) {
          deviceTypeNames.push(this.deviceTypeData[i].deviceTypeName);
        }
        for (var i = 0; i < this.xmflData.length; i++) {
          projectTypeNames.push(this.xmflData[i].name);
        }
        for (var i = 0; i < this.deviceStatuData.length; i++) {
          deviceStatus.push(this.deviceStatuData[i].statusName);
        }
        for (var i = 0; i < this.deviceinfoList.length; i++) {
          if (
            this.deviceinfoList[i][1] == null ||
            this.deviceinfoList[i][1].length < 0 ||
            this.deviceinfoList[i][1] == "" ||
            this.deviceinfoList[i][3] == null ||
            this.deviceinfoList[i][3].length < 0 ||
            this.deviceinfoList[i][3] == "" ||
            this.deviceinfoList[i][4] == null ||
            this.deviceinfoList[i][4].length < 0 ||
            this.deviceinfoList[i][4] == "" ||
            this.deviceinfoList[i][5] == null ||
            this.deviceinfoList[i][5].length < 0 ||
            this.deviceinfoList[i][5] == "" ||
            this.deviceinfoList[i][6] == null ||
            this.deviceinfoList[i][6].length < 0 ||
            this.deviceinfoList[i][3] == "" ||
            this.deviceinfoList[i][7] == null ||
            this.deviceinfoList[i][7].length < 0 ||
            this.deviceinfoList[i][7] == "" ||
            this.deviceinfoList[i][8] == null ||
            this.deviceinfoList[i][8].length < 0 ||
            this.deviceinfoList[i][8] == "" ||
            this.deviceinfoList[i][9] == null ||
            this.deviceinfoList[i][9].length < 0 ||
            this.deviceinfoList[i][9] == "" ||
            this.deviceinfoList[i][10] == null ||
            this.deviceinfoList[i][10].length < 0 ||
            this.deviceinfoList[i][10] == "" ||
            this.deviceinfoList[i][11] == null ||
            this.deviceinfoList[i][11].length < 0 ||
            this.deviceinfoList[i][11] == "" ||
            this.deviceinfoList[i][15] == null ||
            this.deviceinfoList[i][15].length < 0 ||
            this.deviceinfoList[i][15] == "" ||
            this.deviceinfoList[i][16] == null ||
            this.deviceinfoList[i][16].length < 0 ||
            this.deviceinfoList[i][16] == ""
          ) {
            isTrue = false;
            this.$message({
              message: "文件第" + (i + 3) + "行必填项空缺，请填写后再导入",
              type: "warning",
            });
            return;
          } else {
            isTrue = true;
          }
        }
        if (isTrue) {
          this.excelLoadingText = "上传中……";
          this.loading = true;
          this.loadingUtil.showLoading("正在上传中，请稍后……");
          let deviceinfos = [];
          for (var i = 0; i < this.deviceinfoList.length; i++) {
            deviceinfos.push({
              zcmc: this.deviceinfoList[i][1],
              glbh: this.deviceinfoList[i][2],
              sbxh: this.deviceinfoList[i][3],
              sccj: this.deviceinfoList[i][4],
              ccbh: this.deviceinfoList[i][5],
              sydw: this.formateExcelSydw(this.deviceinfoList[i][6]),
              ss: this.deviceinfoList[i][6],
              bgr: this.deviceinfoList[i][7],
              cgrq: this.formateExceldate(this.deviceinfoList[i][8]),
              clfw: this.deviceinfoList[i][9],
              cljd: this.deviceinfoList[i][10],
              yjfl: this.formateExcelyjfl(this.deviceinfoList[i][11]),
              zyfl: this.formateExcelzyfl(this.deviceinfoList[i][12]),
              xmfl: this.formateExcelxmfl(this.deviceinfoList[i][13]),
              ejfl: this.formateExcelejfl(this.deviceinfoList[i][14]),
              jdlx: this.formateExcelJdlx(this.deviceinfoList[i][15]),
              jdzq: this.deviceinfoList[i][16],
              sl: this.deviceinfoList[i][17],
              dw: this.deviceinfoList[i][18],
              ccrq: this.formateExceldate(this.deviceinfoList[i][19]),
              syr: this.deviceinfoList[i][20],
              qyrq: this.formateExceldate(this.deviceinfoList[i][21]),
              glfs: this.deviceinfoList[i][22],
              cfdd: this.deviceinfoList[i][23],
              lrr: this.deviceinfoList[i][24],
              sbzt: this.formateExcelSbzt(this.deviceinfoList[i][25]),
              dbzt: this.formateExcelDbzt(this.deviceinfoList[i][26]),
              bz: this.deviceinfoList[i][27],
            });
          }
          let _params = {
            parameter: JSON.stringify(deviceinfos),
            userId: JSON.parse(localStorage.getItem("user")).userId,
          };
          mktInsertDevices(_params).then((resultData) => {
            let { data, message, status } = resultData;
            if (status == 200) {
              isTrue = false;
              this.loadingUtil.hideLoading();
              this.deviceinfoList = [];
              this.importExcelDialog = false;
              this.fileList = [];
              this.$message({
                message: "导入成功",
                type: "success",
              });
              this.getDeviceinfo();
              this.excelLoading = false;
              this.excelLoadingText = "立即上传";
            } else if (status == 400) {
              this.$message({
                message: message,
                type: "warning",
              });
              this.excelLoading = false;
              this.excelLoadingText = "立即上传";
              this.loadingUtil.hideLoading();
            } else {
              this.$message({
                message: message,
                type: "error",
              });
              this.excelLoading = false;
              this.excelLoadingText = "立即上传";
              this.loadingUtil.hideLoading();
            }
          });
        }
      }
    },
    importfxx(obj) {
      let _this = this;
      // 通过DOM取文件数据
      this.file = obj;
      var rABS = false; //是否将文件读取为二进制字符串
      var f = this.file;
      var reader = new FileReader();
      FileReader.prototype.readAsBinaryString = function (f) {
        var binary = "";
        var rABS = false; //是否将文件读取为二进制字符串
        var pt = this;
        var wb; //读取完成的数据
        var outdata;
        var reader = new FileReader();
        reader.onload = function (e) {
          var bytes = new Uint8Array(reader.result);
          console.log(reader.result);
          var length = bytes.byteLength;
          for (var i = 0; i < length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          var XLSX = require("xlsx");
          if (rABS) {
            wb = XLSX.read(btoa(fixdata(binary)), {
              //手动转化
              type: "base64",
            });
          } else {
            wb = XLSX.read(binary, {
              type: "binary",
            });
          }
          const worksheet = wb.Sheets[wb.SheetNames[0]];
          outdata = XLSX.utils.sheet_to_json(worksheet, { header: 1 }); //outdata就是读取excel内容之后输出的东西
          this.da = [...outdata];
          let arr = [];
          let arrlist = [];
          _this.deviceinfoList = [];
          this.da.map((v, index) => {
            if (index > 1) {
              arr = [];
              // if(v[1]==null){
              //     return
              // }else{\
              for (var i = 0; i < outdata[1].length; i++) {
                if (v.length > 0) {
                  arr.push(v[i] != null ? v[i] : "");
                } else {
                  return;
                }
              }
              // }
              _this.deviceinfoList.push(arr);
            }
          });
          // _this.deviceinfoList=arrlist
          console.log(_this.deviceinfoList);
          //return arr
          // 把读取的excel表格中的内容放进tableData2中(这里要改成自己的表的名字)
          // _this.tableData2 = _this.tableData2.concat(arr)
        };
        reader.readAsArrayBuffer(f);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
    },
    //格式化使用单位
    formateExcelSydw(companyName) {
      let companyCode = "";
      for (var i = 0; i < this.companyData.length; i++) {
        if (companyName != null && companyName != "") {
          if (this.companyData[i].companyName == companyName) {
            companyCode = this.companyData[i].companyCode;
          }
        }
      }
      return companyCode;
    },
    // 格式化启用日期
    formateExceldate(dates) {
      let date1 = "";
      const newDate = dates;

      if (newDate != null && newDate != "") {
        if (typeof newDate == "string") {
          let dt = new Date(newDate);
          date1 =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        } else {
          let dt = new Date((newDate - 25569) * 24 * 60 * 60 * 1000);
          let year = dt.getFullYear();
          let month = (dt.getMonth() + 1).toString().padStart(2, "0");
          let date = dt.getDate().toString().padStart(2, "0");
          let hour = dt.getHours().toString().padStart(2, "0");
          let minute = dt.getMinutes().toString().padStart(2, "0");
          let second = dt.getSeconds().toString().padStart(2, "0");
          date1 =
            dt.getFullYear() +
            "-" +
            (dt.getMonth() + 1).toString().padStart(2, "0") +
            "-" +
            dt.getDate().toString().padStart(2, "0");
        }
      }
      return date1;
    },
    // 格式化设备类型
    formateExcelyjfl(yjflName) {
      let yjfl = "";
      if (yjflName != null && yjflName != "" && yjflName != "/") {
        for (var i = 0; i < this.deviceTypeData.length; i++) {
          if (yjflName == this.deviceTypeData[i].deviceTypeName) {
            this.yjid = this.deviceTypeData[i].id;
            yjfl = this.deviceTypeData[i].id;
          }
        }
      } else {
        yjfl = yjflName;
      }
      return yjfl;
    },
    // 格式化项目分类
    formateExcelxmfl(xmflName) {
      let xmfl = "";
      if (xmflName == "无项目") {
        xmfl = "/";
      }
      if (xmflName != null && xmflName != "" && xmflName != "/") {
        for (var i = 0; i < this.deviceTypeData.length; i++) {
          if (
            xmflName == this.deviceTypeData[i].deviceTypeName &&
            this.deviceTypeData[i].level == 3 &&
            this.deviceTypeData[i].pid == this.zyid
          ) {
            this.xmid = this.deviceTypeData[i].id;
            xmfl = this.deviceTypeData[i].code;
          }
        }
      } else {
        xmfl = xmflName;
      }
      return xmfl;
    },
    // 格式化专业分类
    formateExcelzyfl(zyflName) {
      let zyfl = "";
      if (zyflName == "无专业") {
        zyfl = "/";
      }
      if (zyflName != null && zyflName != "" && zyflName != "/") {
        for (var i = 0; i < this.deviceTypeData.length; i++) {
          if (
            zyflName == this.deviceTypeData[i].deviceTypeName &&
            this.deviceTypeData[i].level == 2
          ) {
            this.zyid = this.deviceTypeData[i].id;
            zyfl = this.deviceTypeData[i].code;
          }
        }
      } else {
        zyfl = zyflName;
      }
      return zyfl;
    },
    // 格式化设备分类
    formateExcelejfl(ejflName) {
      let ejfl = "";
      if (ejflName != null && ejflName != "" && ejflName != "/") {
        if (this.yjid == "P0001") {
          for (var i = 0; i < this.deviceTypeData.length; i++) {
            if (ejflName == this.deviceTypeData[i].deviceTypeName) {
              ejfl = this.deviceTypeData[i].id;
            }
          }
        } else {
          for (var i = 0; i < this.deviceTypeData.length; i++) {
            if (
              ejflName == this.deviceTypeData[i].deviceTypeName &&
              this.deviceTypeData[i].pid == this.xmid
            ) {
              ejfl = this.deviceTypeData[i].id;
            }
          }
        }
      } else {
        ejfl = ejflName;
      }
      return ejfl;
    },
    // 格式化设备状态
    formateExcelSbzt(status) {
      let sbzt = "";
      if (status != null && status != "" && status != "/") {
        for (var i = 0; i < this.deviceStatuData.length; i++) {
          if (status == this.deviceStatuData[i].statusName) {
            sbzt == this.deviceStatuData[i].id;
          }
        }
      }
      return sbzt;
    },
    // 格式化调拨状态
    formateExcelDbzt(status) {
      let dbzt = status == "可调拨" ? 0 : 1;
      return dbzt;
    },
    // 格式化检定类型
    formateExcelJdlx(jdlxs) {
      let jdlx = 0;
      if (jdlxs == "检定") {
        jdlx = 0;
      } else if (jdlxs == "校准") {
        jdlx = 2;
      } else if (jdlxs == "设备核查") {
        jdlx = 1;
      } else if (jdlxs == "不检定/校准") {
        jdlx = 3;
      }
      return jdlx;
    },
  },
  created() {
    this.selectAllLables();
    this.getCompanyTree();
    this.getDeviceinfo();
    this.getfenleiData();
    this.getOptions();
    this.userinfo = JSON.parse(localStorage.getItem("user"));
    console.log('userinfo', this.userinfo);
    this.btnRole = this.userinfo.role.menuId.split(",");
  },
  mounted() {
    // 如果从 MktRecord 跳过来编辑草稿（sessionStorage 里有 id），自动打开弹窗并回填
    const editId = sessionStorage.getItem("editBorrowDraftId");
    if (editId) {
      sessionStorage.removeItem("editBorrowDraftId");
      this.openBorrowDialogForEdit(parseInt(editId));
    }
  },
  watch: {
    check(newVal) {
      if (newVal) {
        var arr = this.checkList.filter((i) => newVal.indexOf(i) < 0); //未选中
        this.deviceTable.map((i) => {
          if (arr.indexOf(i.label) !== -1) {
            i.ispass = false;
          } else {
            i.ispass = true;
            this.$nextTick(() => {
              this.$refs.deviceTable.doLayout();
            });
          }
        });
      }
    },
  },
};
</script>
<style scoped>
.btn {
  float: left;
}

.statueBtn {
  padding: 10px 10px;
  border: 0px;
  float: left;
  margin-left: 10px;
}

.statueSpan {
  vertical-align: middle;
  float: left;
  margin-left: 5px;
}

/* .el-input__inner{
    height:40px!important
} */
</style>
<style>
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style lang="less" scoped>
#deviceTable {
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    /*滚动条宽度*/
    height: 15px;
    /*滚动条高度*/
    margin-top: 100px;
  }

  /* 给固定列设置下边距 */
  /deep/ .el-table__fixed {
    height: auto !important;
    bottom: 15px !important;
    /* 具体值是多少根据你横向滚动条的高度进行设置 */
  }

  /deep/ .el-table__fixed-left {
    height: 100% !important;
  }

  /* 去掉固定列下方的横线 */
  /deep/ .el-table__fixed::before,
  .el-table__fixed-left::before {
    display: none;
  }

  /*定义滚动条轨道 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background: #ededed;
  }

  /*定义滑块 内阴影+圆角*/
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background: #cfcbcb;
  }

  /deep/ .el-table__fixed-body-wrapper {
    height: calc(100% -57px) !important;
    padding-bottom: 17px;
    box-sizing: content-box;
  }

  /deep/ .tr-diaobo {
    color: red !important;
  }

  /deep/ .tr-baofei {
    color: #580fda !important;
  }

  /deep/ .tr-jiandin {
    color: #f4de5c !important;
  }
}

.el-table--border {
  border-color: #000000 !important;
  width: 320px;
  border-right: 1px solid #000000 !important;
  border-bottom: 1px solid #000000 !important;
}

#table /deep/ .cell {
  padding-left: 2px !important;
  padding-right: 0px !important;
}

.docx-wrapper {
  background: white !important;
  padding: 10px;
}

.docx {
  padding: 0pt 20.65pt 20pt 20.55pt !important;
  width: 789.9pt !important;
  min-height: 0px !important;
  margin-top: -30px !important;
  margin-left: -10px !important;
}

/deep/ .cascader .el-input .el-input__inner::placeholder {
  color: #606266;
}

/deep/ .required .el-form-item__label::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

::v-deep .el-table .cell {
  text-align: left !important;
}
</style>



// WEBPACK FOOTER //
// src/views/market/Market.vue